const auditIndex = ((jQuery) => {
  'use strict';

  let oTable;
  const $auditsTreeTable = jQuery('#audits_tree_table');
  if ($auditsTreeTable.length === 0) {
    return;
  }

  const initTreeTable = () => {
    oTable = $auditsTreeTable.treeTable({
      data: window.campaignsListData,
      collapsed: true,
      autoWidth: false,
      pageLength: 100,
      stateSave: true,
      language: {url: '/vendor/datatables/' + AppLocale + '.json'},
      columns: [
        {data: 'link'},
        {data: 'user'},
        {data: 'brand'},
        {data: 'audit'},
        {data: 'budget'},
        {data: 'dates'},
        {data: 'date_audit'},
        {data: 'nb_io'},
        {data: 'nb_li'},
        {data: 'actions'},
      ],
      columnDefs: [
        {targets: 'no-sort', orderable: false},
        {"className": "dt-center", "targets": "center"},
      ],
      initComplete: () => {
        $auditsTreeTable.removeClass('d-none');
      }
    })
  };

  jQuery(() => {
    initTreeTable();
  });

})(jQuery);
